// Default States for Talent Manager Module
export const GLOBAL_LOADING = "GLOBAL_LOADING";
export const STATE_ERROR = "STATE_ERROR";
export const STATE_LOADING = "STATE_LOADING";
